module.exports = __webpack_public_path__ + "media/promo/hochland/images/ball6-ad679a5d82b931dbf6559272763ec754.png";